/* DCG V3.1.0 · 17 OCT 2026 · the decisions round (D-SP-32 LOCKED with one change; Cole, 17 OCT; REPORT-V3-1-0-final §7.3 (b)): no stock badge on a sold-out card (the home row, related products, the 404 row, the coming-soon row, the safety net, Advanced Search's BinderPOS view); "N left" and "In stock" as before */
/* DCG V3.1.0 · 17 OCT 2026 · item 10 (the rename round; Cowork's audit of 17 OCT): the card's − / + are named with the card ("Decrease quantity for …", as the StorePass card's since v2-10-11), and its cart button, a picture only (its words are not shown), is named too ("Add to Cart for …", "Pre-Order for …") */
/* DCG V3.1.0 · 17 OCT 2026 · item 0 (D-SP-41 amended, LOCKED, Cole 17 OCT): no wishlist heart on the DCG card (the home row, related products, the 404 page, the coming-soon row; buildWishlistWrap, its click handler and dcgRestoreWishlist are gone); the product page's Add To Wishlist (shop.js) and /pages/wishlist unchanged */
/* DCG v2-10-13 · 16 OCT 2026 · item 3: an in-store event's notice reads "Register in store" (a retail product that is not an event: "In-store only", as before); item 1: the heart's rule is in dcg-product-card.css (D-SP-41) */
/* DCG v2-10-12 · 16 OCT 2026 · item 4 (D-SP-40, PROPOSED): a retail card shows no stock marks, whatever its inventory: no sold-out state or veil, no stock badge, its conditions not marked sold out */
/* DCG v2-8-1 · 10 OCT 2026 · change group C4, C5 · D-SP-14 · wishlist cookie holds the handle (v2-6-2) · the condition label wraps and is never cut (v2-8-1) */
(() => {
  // ─────────────────────────────────────────────────────────────────────────
  // global.js setGridLayout() replaces every <li> className on DOMContentLoaded
  // stripping class-based selectors. data-product-id is an attribute — immune.
  // ─────────────────────────────────────────────────────────────────────────
  const CARD_SELECTOR = '[data-product-id], .dcg-related-products__item';

  const CART_SVG = '<svg class="dcg-atc-icon" viewBox="0 0 20 20" fill="none" stroke="#fff" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 3h2l2.5 8h8l2-6H6"/><circle cx="9" cy="16.5" r="1.4" fill="#fff" stroke="none"/><circle cx="15" cy="16.5" r="1.4" fill="#fff" stroke="none"/></svg>';
  const CHECK_SVG = '<svg class="dcg-atc-icon" viewBox="0 0 20 20" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="4 10 8.5 15 16 6"/></svg>';

  // Expose CHECK_SVG globally so dcg-cart-bridge.js can use it without import
  window.DCG = window.DCG || {};
  window.DCG.CHECK_SVG = CHECK_SVG;

  // ── Helpers ───────────────────────────────────────────────────────────────

  function parseVariants(li) {
    try { return JSON.parse(li.getAttribute('data-product-variants') || '[]'); }
    catch (_) { return []; }
  }

  // parseInventory reads the Liquid-stamped inventory map from data-variant-inventory.
  // This mirrors product-template.liquid's variantsInventoryQty/Policy objects:
  // server-rendered by Liquid so always accurate — never from the JSON blob.
  // Returns: { [variantId]: { qty, policy, management } }
  function parseInventory(li) {
    try { return JSON.parse(li.getAttribute('data-variant-inventory') || '{}'); }
    catch (_) { return {}; }
  }

  // effectiveStockForVariant reads from the Liquid-rendered inventory map.
  // Same logic as dcg-qty-guard.js getSelectedVariantStock():
  //   management blank → untracked → null (no cap)
  //   policy 'continue' → oversell allowed → null (no cap)
  //   policy 'deny' + qty → capped at qty
  function effectiveStockForVariant(inventoryMap, variantId) {
    const entry = inventoryMap[String(variantId)];
    if (!entry) return null;
    const mgmt = (entry.management || '').toLowerCase();
    if (!mgmt) return null;
    const policy = (entry.policy || '').toLowerCase();
    if (policy === 'continue') return null;
    const qty = Math.max(0, Number(entry.qty) || 0);
    // qty=0 with a tracked management policy almost always means BinderPOS
    // hasn't synced inventory_quantity to Shopify (only available:true/false is
    // reliable from BinderPOS). Treat as uncapped — the cart enforces real stock.
    return qty > 0 ? qty : null;
  }

  function parseLimitFromTags(li) {
    // Reads data-product-tags="[...]" and returns the lowest limit:N value,
    // or null if no limit tag found. Matches both limit:N and limit-N formats
    // to stay consistent with dcg-qty-guard.js on the product page.
    try {
      const raw = li.getAttribute('data-product-tags') || '[]';
      const tags = JSON.parse(raw);
      // Prefer the shared parser (dcg-utils.js) — single source of truth.
      if (window.DCG && typeof window.DCG.parseLimit === 'function') {
        return window.DCG.parseLimit(tags);
      }
      const limits = [];
      for (const tag of tags) {
        const t = String(tag).trim().toLowerCase();
        const m = t.match(/^limit[-:](\d{1,3})$/);
        if (m) {
          const n = Number(m[1]);
          if (Number.isFinite(n) && n > 0) limits.push(n);
        }
      }
      return limits.length ? Math.min(...limits) : null;
    } catch (_) { return null; }
  }

  function parseTags(li) {
    try {
      const tags = JSON.parse(li.getAttribute('data-product-tags') || '[]');
      return Array.isArray(tags) ? tags : [];
    } catch (_) { return []; }
  }

  // ── Price pending (D-SP-14) ───────────────────────────────────────────────
  // A variant priced 0 cannot be ordered: the card shows "Price pending" in the
  // price area and no Add to Cart. Products tagged `event-ticket` are exempt
  // (free events are $0.00 on purpose). Same rule as dcg-cart-enforcer.js §3b,
  // which blocks the add itself; this is the card's side of it.
  function isPricePending(variant, tags) {
    if (!variant || variant.price === null || variant.price === undefined || variant.price === '') return false;
    if (Number(variant.price) !== 0) return false;
    return !tags.some(t => String(t).trim().toLowerCase() === 'event-ticket');
  }

  // Add to Cart + quantity ⇄ "Price pending" notice, for the selected variant.
  // Only acts on a row that has cart controls (in-stock and pre-order cards):
  // retail, coming-soon and sold-out rows have none and are left as built.
  // Runs at build time and on every condition change, so switching to a priced
  // condition brings the controls back.
  function applyPricePending(li, variant) {
    const card = li.querySelector('.dcg-product-card');
    const row3 = card && card.querySelector('.dcg-card-row3');
    const qtyWrap = row3 && row3.querySelector('.dcg-qty');
    if (!qtyWrap) return;

    const pending   = isPricePending(variant, parseTags(li));
    const actionsEl = row3.querySelector('.add_to_cart_main');
    const atcBtn    = row3.querySelector('.nm-addToCart');
    const limitMsg  = row3.querySelector('.dcg-qty-limit-msg');
    let notice      = row3.querySelector('.dcg-price-notice');

    [qtyWrap, actionsEl, limitMsg].forEach(el => {
      if (!el) return;
      if (pending) {
        el.style.setProperty('display', 'none', 'important');
        el.setAttribute('data-dcg-price-hidden', '');
      } else if (el.hasAttribute('data-dcg-price-hidden')) {
        el.style.removeProperty('display');
        el.removeAttribute('data-dcg-price-hidden');
      }
    });

    // shop.js adds to cart on `.nm-addToCart.enable`: take the class away as
    // well, so a click can't start an add even if the button were shown.
    if (atcBtn) {
      atcBtn.disabled = pending;
      atcBtn.classList.toggle('enable', !pending);
      atcBtn.classList.toggle('disabled', pending);
    }

    if (pending && !notice) {
      // Same box as the retail notice (dcg-product-card.css .dcg-retail-notice).
      notice = document.createElement('div');
      notice.className = 'dcg-retail-notice dcg-price-notice';
      notice.innerHTML = '<span class="dcg-retail-notice__text">Price pending</span>';
      row3.insertBefore(notice, row3.firstChild);
    } else if (!pending && notice) {
      notice.remove();
    }
  }

  function findVariant(variants, id) {
    return variants.find(v => String(v.id) === String(id)) || null;
  }

  function stockOf(v) { return Math.max(0, Number(v.inventory_quantity) || 0); }

  // effectiveStock mirrors the product page's data-stock logic:
  // returns the purchasable cap (null = uncapped/backorder/untracked).
  // inventory_management blank = untracked = no cap.
  // inventory_policy "continue" = allow oversell = no cap.
  // inventory_policy "deny" + qty > 0 = capped at qty.


  function isAvailable(v) { return v.available === true; }

  function pipClass(v) {
    if (!isAvailable(v)) return 's-no';
    const qty = stockOf(v);
    if (qty > 0 && qty <= 4) return 's-low';
    return 's-in';
  }

  // V3.1.0, the decisions round (D-SP-32 LOCKED with one change; Cole, 17 OCT; REPORT-V3-1-0-final §7.3 (b)): no
  // badge for a variant with no stock ("Out of stock" until then): a sold-out card's Sold Out picture and its button
  // say it. The badge stays in its place, hidden and empty, as a retail card's (buildCardUI, onConditionChange).
  function pipLabel(v) {
    if (!isAvailable(v)) return '';
    const qty = stockOf(v);
    if (qty > 0) return qty + ' left';
    return 'In stock';
  }

  function formatMoney(cents) {
    if (cents == null || cents === '') return '';
    if (typeof cents === 'string' && cents.includes('$')) return cents;
    return '$' + (Number(cents) / 100).toFixed(2);
  }

  function detectRarity(variants) {
    const t = ((variants[0] || {}).title || '').toLowerCase();
    if (t.includes('mythic'))   return 'mythic';
    if (t.includes('rare'))     return 'rare';
    if (t.includes('uncommon')) return 'uncommon';
    if (t.includes('common'))   return 'common';
    return null;
  }

  function isFoilVariant(v) {
    return (v.title || '').toLowerCase().includes('foil');
  }

  // ── Classify product as trading card single vs sealed/other ───────────────
  // The most reliable signal: singles have condition-graded variants
  // (Near Mint, Lightly Played, Heavily Played, etc.). Sealed products have
  // variants like "Default Title", "Booster Box", "Blister Pack" — never
  // condition grades. This works for ALL TCGs regardless of tags or type.
  const CONDITION_PATTERNS = [
    'near mint', 'lightly played', 'moderately played', 'heavily played',
    'damaged', 'nm', 'lp', 'mp', 'hp', 'dmg',
    'graded', 'psa', 'bgs', 'cgc',
    '1st edition', 'unlimited', 'limited edition',
    'foil', 'reverse foil', 'holo', 'non-holo',
    'first edition', 'shadowless'
  ];

  // Secondary: tag/type fallback for edge cases
  const SINGLES_TYPE_PATTERNS = [
    'single', 'singles', 'trading card', 'tcg single', 'card single',
    'yu-gi-oh', 'yugioh', 'magic', 'pokemon', 'one piece', 'flesh and blood',
    'riftbound', 'grand archive', 'digimon', 'cardfight', 'weiss'
  ];
  const SINGLES_TAG_PATTERNS = [
    'single', 'singles', 'tcg-single', 'tcg_single',
    'magic-single', 'mtg-single', 'pokemon-single',
    'yugioh-single', 'ygo-single', 'fab-single',
    'one-piece-single', 'flesh-and-blood-single', 'riftbound-single'
  ];

  function isSingleCard(li) {
    // 1. Condition-variant detection — strongest signal
    try {
      const variants = JSON.parse(li.getAttribute('data-product-variants') || '[]');
      if (variants.length > 0) {
        const hasConditionVariant = variants.some(v => {
          const t = (v.title || '').toLowerCase();
          return CONDITION_PATTERNS.some(p => t.includes(p));
        });
        if (hasConditionVariant) return true;
      }
    } catch (_) {}

    // 2. Product type match
    const type = (li.getAttribute('data-product-type') || '').toLowerCase();
    if (SINGLES_TYPE_PATTERNS.some(p => type.includes(p))) return true;

    // 3. Tag fallback
    try {
      const tags = JSON.parse(li.getAttribute('data-product-tags') || '[]');
      if (tags.some(t => SINGLES_TAG_PATTERNS.some(p => t.toLowerCase().includes(p)))) return true;
    } catch (_) {}

    return false;
  }

  // ── Build custom card UI ───────────────────────────────────────────────────

  function buildCardUI(li, variants, limitFromTags, inventoryMap) {
    const card = li.querySelector('.dcg-product-card');
    if (!card) return;

    // ── 1. Save references before any DOM changes ──────────────────────────
    const content    = card.querySelector('.grid-view-item__meta, .dcg-product-card__content');
    const titleEl    = card.querySelector('.dcg-product-card__title a, .grid-view-item__title a, .product-card__title a');
    const priceWrap  = card.querySelector('.product-price__price, .dcg-product-card__price');
    const mediaEl    = card.querySelector('.grid-view-item__image-container, .dcg-product-card__media');
    const actionsEl  = card.querySelector('.add_to_cart_main');
    const atcBtn     = card.querySelector('.nm-addToCart');
    const hiddenVar  = card.querySelector('input[name="prduct-variant"]');
    const hiddenQty  = card.querySelector('input[name="product-quantity"]');
    // V3.1.0 (item 10): the card's own name, in the names of its buttons, as the StorePass card has them (v2-10-11)
    const cardName   = titleEl ? titleEl.textContent.replace(/\s+/g, ' ').trim() : '';
    const forName    = cardName ? ' for ' + cardName : '';

    if (!content || !actionsEl || !atcBtn) return;

    // ── 2. Wrap media ──────────────────────────────────────────────────────
    if (mediaEl && !card.querySelector('.dcg-card-top')) {
      const top = document.createElement('div');
      top.className = 'dcg-card-top';
      mediaEl.parentNode.insertBefore(top, mediaEl);
      top.appendChild(mediaEl);
    }
    if (mediaEl) mediaEl.classList.add('dcg-product-card__media');

    // ── 2b. Singles vs Sealed background ─────────────────────────────────
    // CSS reacts to .dcg-media--single (dark stage) or .dcg-media--sealed
    // (white stage). Default in CSS is dark until one of these is set.
    if (mediaEl) {
      if (isSingleCard(li)) {
        mediaEl.classList.add('dcg-media--single');
      } else {
        mediaEl.classList.add('dcg-media--sealed');
      }
    }

    // ── 3. Rarity badge ───────────────────────────────────────────────────
    if (mediaEl && !card.querySelector('.dcg-rarity-badge')) {
      const rarity = detectRarity(variants);
      if (rarity) {
        const rb = document.createElement('span');
        rb.className = `dcg-rarity-badge dcg-rarity-badge--${rarity}`;
        rb.textContent = rarity.charAt(0).toUpperCase() + rarity.slice(1);
        mediaEl.appendChild(rb);
      }
    }

    // ── 3b. Retail Only badge ─────────────────────────────────────────────
    if (mediaEl && !card.querySelector('.dcg-retail-badge')) {
      try {
        const tags = JSON.parse(li.getAttribute('data-product-tags') || '[]');
        if (tags.some(t => t.toLowerCase() === 'retail')) {
          const rb = document.createElement('div');
          rb.className = 'dcg-retail-badge';
          rb.textContent = 'Retail Only';
          mediaEl.appendChild(rb);
        }
      } catch (_) {}
    }

    // ── 4. Foil overlay ───────────────────────────────────────────────────
    const selectedId      = hiddenVar ? hiddenVar.value : (variants[0] ? String(variants[0].id) : null);
    const selectedVariant = findVariant(variants, selectedId) || variants[0];
    const cardTop = card.querySelector('.dcg-card-top');
    if (selectedVariant && isFoilVariant(selectedVariant) && cardTop && !cardTop.querySelector('.dcg-foil-badge')) {
      const badge = document.createElement('span'); badge.className = 'dcg-foil-badge'; badge.textContent = 'Foil';
      cardTop.appendChild(badge);
    }

    // ── 5. Sold-out veil ──────────────────────────────────────────────────
    const isSoldOut = !variants.some(v => isAvailable(v)) || card.classList.contains('sold-out');
    // Suppress sold-out styling for coming-soon — these are intentionally unavailable
    const _csTagCheck = li.getAttribute('data-product-tags') || '[]';
    const _isCS = _csTagCheck.includes('"coming-soon"') || _csTagCheck.includes("'coming-soon'");
    // DCG v2-10-12 (item 4; Cole, 16 OCT; D-SP-40, PROPOSED): a retail card is bought in store only, so it shows
    // no stock marks whatever its inventory: no sold-out state or veil here, no badge in row 1, and its conditions
    // are not marked sold out (its Retail Only badge and "In-store only · Contact us" row say how it is bought)
    let _isRetail = false;
    try { _isRetail = JSON.parse(_csTagCheck).some(t => String(t).toLowerCase() === 'retail'); } catch (_) {}
    if (isSoldOut && !_isCS && !_isRetail) { card.classList.add('sold-out'); } else if (!isSoldOut || _isRetail) { card.classList.remove('sold-out'); }
    // Mark coming-soon cards so CSS can override opacity:0.62 from sold-out class
    if (_isCS) { card.classList.add('dcg-coming-soon-card'); } else { card.classList.remove('dcg-coming-soon-card'); }
    if (isSoldOut && !_isCS && !_isRetail && mediaEl && !mediaEl.querySelector('.dcg-sold-veil')) {
      const veil = document.createElement('div'); veil.className = 'dcg-sold-veil';
      const pill = document.createElement('span'); pill.className = 'dcg-sold-veil__pill'; pill.textContent = 'Sold Out';
      veil.appendChild(pill); mediaEl.appendChild(veil);
    }

    // ── 6. Resolve variants and price strings ─────────────────────────────
    const inStock = variants.filter(v => isAvailable(v));
    const moneyEls = priceWrap ? priceWrap.querySelectorAll('.money') : [];
    let priceStr = '', compareStr = '';
    if (moneyEls.length >= 2) { compareStr = moneyEls[0].textContent.trim(); priceStr = moneyEls[1].textContent.trim(); }
    else if (moneyEls.length === 1) { priceStr = moneyEls[0].textContent.trim(); }

    const isDefaultTitle = variants.length === 1 && (variants[0].title || '').toLowerCase() === 'default title';

    // ── 7. Build content fragment ──────────────────────────────────────────
    const frag = document.createDocumentFragment();

    // ── Row 1: native condition select + stock pip ─────────────────────────
    // Mirrors Top Singles .dcg-pb__select using design-system tokens.
    const row1 = document.createElement('div');
    row1.className = 'dcg-card-row1';

    // Declare pip before the select's change handler so the closure captures it
    const pip = document.createElement('span');
    // For coming-soon cards, suppress the "Out of stock" pip label — the
    // Coming Soon badge already communicates this. Use a neutral availability state.
    // DCG v2-10-12 (item 4): and for retail cards (above)
    const _pipIsCS = _isCS || _isRetail;
    // V3.1.0, the decisions round: and a sold-out card's (pipLabel), hidden and empty the same way
    pip.className = `dcg-stock-pip ${_pipIsCS ? 's-no dcg-cs-pip' : (selectedVariant ? pipClass(selectedVariant) : 's-no')}`;
    pip.textContent = (_pipIsCS || !selectedVariant) ? '' : pipLabel(selectedVariant);
    if (!pip.textContent) pip.style.display = 'none';

    const selectEl = document.createElement('select');
    selectEl.className = 'dcg-card-cond-select';
    selectEl.setAttribute('aria-label', 'Select condition');

    if (isDefaultTitle) {
      selectEl.style.display = 'none';
    } else if ((isSoldOut || inStock.length === 0) && !_isRetail) {
      const opt = document.createElement('option');
      opt.textContent = 'Sold out';
      selectEl.appendChild(opt);
      selectEl.disabled = true;
      selectEl.classList.add('is-sold-out');
    } else {
      // Browse contexts: render ALL variants (with sold-out marked disabled),
      // so customers can compare prices across every condition.
      //  - Search results page (.dcg-search-list-item)
      //  - Related-products carousel below product pages (.dcg-related-products__item)
      //  - Advanced search results (cards inside #shopify-section-advanced_search)
      // Collection cards stay in-stock-only to preserve their tighter
      // quick-buy UX — customers there are scanning fast and want only what's
      // actually purchasable.
      const isBrowseContext = li.classList && (
        li.classList.contains('dcg-search-list-item') ||
        li.classList.contains('dcg-related-products__item') ||
        (li.closest && li.closest('#shopify-section-advanced_search'))
      );
      // DCG v2-10-12 (item 4): a retail card lists every condition, none marked sold out
      const variantsToRender = (isBrowseContext || _isRetail) ? variants : inStock;
      variantsToRender.forEach(v => {
        const opt = document.createElement('option');
        opt.value = String(v.id);
        // Stamp data-stock exactly as the product page Liquid does,
        // so dcg-qty-guard-style logic can read from the DOM (reliable).
        opt.dataset.stock             = String(v.inventory_quantity ?? '');
        opt.dataset.inventoryPolicy   = String(v.inventory_policy   || '');
        opt.dataset.inventoryManagement = String(v.inventory_management || '');
        const qty = stockOf(v);
        if (!v.available && !_isRetail) {
          opt.textContent = `${v.title}  - Sold Out`;
          opt.disabled = true;
        } else {
          // 17 AUG 2026: no qty suffix — the stock pip ("N left") beside the
          // select already shows the count; "(N)" here duplicated it.
          opt.textContent = v.title;
        }
        if (String(v.id) === String(selectedId)) opt.selected = true;
        selectEl.appendChild(opt);
      });

      if (variantsToRender.length > 1) {
        selectEl.addEventListener('change', () => {
          const v = findVariant(variants, selectEl.value);
          if (v) onConditionChange(li, v, selectEl, pip, hiddenVar, hiddenQty);
        });
      } else {
        // Single option — hide chevron and block interaction
        selectEl.classList.add('no-arrow');
      }
    }

    row1.appendChild(selectEl);

    // DCG v2-8-1 — the condition label is never cut. A closed <select> cannot
    // wrap its text, and beside an "Out of stock" pip a label such as
    // "Near Mint Foil" lost its end. The label is now a span that has the
    // select's frame and wraps; the select lies over the row, invisible, and
    // is still what is clicked, focused and announced (dcg-product-card.css,
    // .dcg-card-cond-label). The StorePass card does the same
    // (dcg-storepass.css, .dcg-cond-label): the two cards stay alike (D-SP-16).
    if (!isDefaultTitle) {
      const condLabel = document.createElement('span');
      condLabel.className = 'dcg-card-cond-label';
      condLabel.setAttribute('aria-hidden', 'true');
      if (selectEl.classList.contains('is-sold-out')) condLabel.classList.add('is-sold-out');
      if (selectEl.classList.contains('no-arrow')) condLabel.classList.add('no-arrow');
      const syncCondLabel = () => {
        const v = findVariant(variants, selectEl.value);
        const opt = selectEl.options[selectEl.selectedIndex];
        const text = selectEl.disabled ? 'Sold out' : (v && v.title ? String(v.title) : (opt ? opt.textContent : ''));
        if (condLabel.textContent !== text) condLabel.textContent = text;
      };
      syncCondLabel();
      selectEl.addEventListener('change', syncCondLabel);
      row1.classList.add('has-cond-label');
      row1.appendChild(condLabel);
    }

    row1.appendChild(pip);
    frag.appendChild(row1);

    // ── Row 2: name + price ────────────────────────────────────────────────
    const row2 = document.createElement('div');
    row2.className = 'dcg-card-row2';

    const nameLink = document.createElement('a');
    nameLink.className = 'dcg-card-name';
    nameLink.href = titleEl ? (titleEl.getAttribute('href') || '#') : '#';
    nameLink.textContent = titleEl ? titleEl.textContent.trim() : '';

    const priceBlock = document.createElement('div');
    priceBlock.className = 'dcg-card-price-block';
    _renderPrice(priceBlock, selectedVariant, priceStr, compareStr, isPricePending(selectedVariant, parseTags(li)));

    row2.appendChild(nameLink);
    row2.appendChild(priceBlock);
    frag.appendChild(row2);

    // ── Row 3: qty + ATC ───────────────────────────────────────────────────
    const row3 = document.createElement('div');
    row3.className = 'dcg-card-row3';

    // ── Resolve all tag states once ──────────────────────────────────
    // retail > coming-soon = pre-order > default
    // retail always disables cart regardless of other tags.
    let _cardTags = [];
    try { _cardTags = JSON.parse(li.getAttribute('data-product-tags') || '[]'); } catch (_) {}
    const _tl       = t => t.toLowerCase();
    const isRetailCard    = _cardTags.some(t => _tl(t) === 'retail');
    const isComingSoon    = _cardTags.some(t => _tl(t) === 'coming-soon');
    const isPreOrderCard  = _cardTags.some(t => _tl(t) === 'pre-order');

    // ── Helper: extract release date from product title ───────────────
    // Matches [YYYY-MM-DD] and formats as "May 22, 2026"
    function extractReleaseDate(titleText) {
      const m = (titleText || '').match(/\[(\d{4})-(\d{2})-(\d{2})\]/);
      if (!m) return null;
      try {
        const d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
        return d.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
      } catch (_) { return null; }
    }

    // ── BRANCH 1: Retail — always wins, cart always disabled ──────────
    if (isRetailCard) {
      const thumbBtns = card.querySelector('.thumbnail-buttons');
      if (thumbBtns) thumbBtns.style.setProperty('display', 'none', 'important');

      const retailNotice = document.createElement('div');
      retailNotice.className = 'dcg-retail-notice';

      if (isPreOrderCard) {
        // Retail + Pre-Order: contact store to pre-order
        retailNotice.innerHTML =
          '<span class="dcg-retail-notice__text">Pre-order in-store</span>' +
          '<a href="/pages/contact" class="dcg-retail-notice__link">Contact us &rarr;</a>';
      } else {
        // Retail alone: standard in-store only. DCG v2-10-13 (item 3; Cole, 16 OCT, HANDOFF §8 14:00Z: "Register in
        // store · Contact us" on event cards everywhere): an event (data-dcg-event, snippets/dcg-product-card.liquid;
        // tagged event-ticket) reads "Register in store"; every other retail product "In-store only", as before.
        const isEventCard = li.hasAttribute('data-dcg-event') || _cardTags.some(t => _tl(t) === 'event-ticket');
        retailNotice.innerHTML =
          '<span class="dcg-retail-notice__text">' + (isEventCard ? 'Register in store' : 'In-store only') + '</span>' +
          '<a href="/pages/contact" class="dcg-retail-notice__link">Contact us &rarr;</a>';
      }

      row3.appendChild(retailNotice);
      actionsEl.style.setProperty('display', 'none', 'important');
      row3.appendChild(actionsEl);

    // ── BRANCH 2: Coming Soon — no cart: the release date and Notify Me ─
    } else if (isComingSoon) {
      // Add Coming Soon badge to dcg-card-top (matches foil/retail badge pattern)
      const csCardTop = card.querySelector('.dcg-card-top');
      if (csCardTop && !csCardTop.querySelector('.dcg-coming-soon-badge')) {
        const csBadge = document.createElement('span');
        csBadge.className = 'dcg-coming-soon-badge';
        csBadge.textContent = 'Coming Soon';
        csCardTop.appendChild(csBadge);
      }

      // Extract release date from title
      const titleText = li.querySelector('.dcg-card-name')
        ? li.querySelector('.dcg-card-name').textContent
        : (titleEl ? titleEl.textContent : '');
      const releaseDate = extractReleaseDate(titleText);

      // row3: the release date, then Notify Me (V3.1.0, item 0: the heart that began the row is gone)
      if (releaseDate) {
        const csLabel = document.createElement('span');
        csLabel.className = 'dcg-coming-soon-label';
        csLabel.textContent = 'Releasing ' + releaseDate;
        row3.appendChild(csLabel);
      }

      // (17 AUG 2026, B1) Coming-soon cards get a Notify Me button that
      // deep-links to the PDP's capture component (#dcg-notify).
      const csNotifyBtn = document.createElement('button');
      csNotifyBtn.className = 'dcg-notify-btn';
      csNotifyBtn.type = 'button';
      csNotifyBtn.innerHTML = `<svg viewBox="0 0 20 20" fill="none" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10 2a6 6 0 0 1 6 6c0 3 1.5 4 1.5 5.5H2.5C2.5 12 4 11 4 8a6 6 0 0 1 6-6z" stroke="currentColor"/><path d="M8 15.5a2 2 0 0 0 4 0" stroke="currentColor"/></svg><span>Notify Me</span>`;
      csNotifyBtn.addEventListener('click', () => {
        const handle = li.getAttribute('data-product-handle');
        if (handle) window.location.href = '/products/' + handle + '#dcg-notify';
      });
      row3.appendChild(csNotifyBtn);

      // Keep ATC hidden — cart disabled
      actionsEl.style.setProperty('display', 'none', 'important');
      row3.appendChild(actionsEl);
      row3.classList.add('dcg-row3--coming-soon');

    // ── BRANCH 3: Pre-Order alone — badge + normal ATC ────────────────
    } else if (isPreOrderCard) {
      // Add Pre-Order badge to dcg-card-top (matches foil/retail badge pattern)
      const poCardTop = card.querySelector('.dcg-card-top');
      if (poCardTop && !poCardTop.querySelector('.dcg-preorder-badge')) {
        const poBadge = document.createElement('span');
        poBadge.className = 'dcg-preorder-badge';
        poBadge.textContent = 'Pre-Order';
        poCardTop.appendChild(poBadge);
      }
      // Fall through to normal in-stock / sold-out logic below
      // (pre-order products are available:true so inStock.length > 0)
      if (!isSoldOut && inStock.length > 0) {
        let currentQty = 1;
        const effStock = effectiveStockForVariant(inventoryMap, selectedId);
        const stockCap = (effStock !== null) ? effStock : 9999;
        const initialMax = (limitFromTags !== null) ? Math.min(stockCap, limitFromTags) : stockCap;

        const qtyWrap = document.createElement('div');
        qtyWrap.className = 'dcg-qty';
        qtyWrap._limitFromTags = limitFromTags;
        qtyWrap._inventoryMap  = inventoryMap;

        const minusBtn = document.createElement('button');
        minusBtn.className = 'dcg-qty__btn off';
        minusBtn.type = 'button';
        minusBtn.setAttribute('aria-label', 'Decrease quantity' + forName);
        minusBtn.textContent = '−';

        const numSpan = document.createElement('span');
        numSpan.className = 'dcg-qty__num';
        numSpan.textContent = '1';

        const plusBtn = document.createElement('button');
        plusBtn.className = 'dcg-qty__btn';
        plusBtn.type = 'button';
        plusBtn.setAttribute('aria-label', 'Increase quantity' + forName);
        plusBtn.textContent = '+';

        const limitMsg = document.createElement('span');
        limitMsg.className = 'dcg-qty-limit-msg';

        function updateLimitMsgPO() {
          const limitTag = qtyWrap._limitFromTags;
          if (limitTag !== null && currentQty >= limitTag) {
            limitMsg.textContent = `Limit ${limitTag} per customer`;
            limitMsg.classList.add('visible');
          } else { limitMsg.classList.remove('visible'); }
        }

        qtyWrap._maxQty = initialMax;
        qtyWrap._getQty = () => currentQty;
        qtyWrap._setMax = newMax => {
          qtyWrap._maxQty = newMax; currentQty = 1;
          numSpan.textContent = 1;
          if (hiddenQty) hiddenQty.value = 1;
          minusBtn.classList.add('off');
          plusBtn.classList.toggle('off', 1 >= newMax);
          updateLimitMsgPO();
        };
        function syncQtyPO() {
          numSpan.textContent = currentQty;
          minusBtn.classList.toggle('off', currentQty <= 1);
          plusBtn.classList.toggle('off', currentQty >= qtyWrap._maxQty);
          if (hiddenQty) hiddenQty.value = currentQty;
          updateLimitMsgPO();
        }
        plusBtn.classList.toggle('off', 1 >= initialMax);
        updateLimitMsgPO();
        minusBtn.addEventListener('click', e => { e.stopPropagation(); if (currentQty > 1) { currentQty--; syncQtyPO(); } });
        plusBtn.addEventListener('click',  e => { e.stopPropagation(); if (currentQty < qtyWrap._maxQty) { currentQty++; syncQtyPO(); } });
        qtyWrap.appendChild(minusBtn);
        qtyWrap.appendChild(numSpan);
        qtyWrap.appendChild(plusBtn);
        row3.appendChild(qtyWrap);

        atcBtn.innerHTML = CART_SVG + '<span class="dcg-atc-label">Pre-Order</span>';
        atcBtn.setAttribute('aria-label', 'Pre-Order' + forName);   // V3.1.0 (item 10): the words above are not shown
        atcBtn.dataset.dcgOrigHtml = atcBtn.innerHTML;

        row3.appendChild(actionsEl);
        row3.appendChild(limitMsg);
      } else {
        // Pre-order but sold out — notify
        const notifyBtn = document.createElement('button');
        notifyBtn.className = 'dcg-notify-btn';
        notifyBtn.type = 'button';
        notifyBtn.innerHTML = `<svg viewBox="0 0 20 20" fill="none" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10 2a6 6 0 0 1 6 6c0 3 1.5 4 1.5 5.5H2.5C2.5 12 4 11 4 8a6 6 0 0 1 6-6z" stroke="currentColor"/><path d="M8 15.5a2 2 0 0 0 4 0" stroke="currentColor"/></svg><span>Notify Me</span>`;
        notifyBtn.addEventListener('click', () => {
          const handle = li.getAttribute('data-product-handle');
          if (handle) window.location.href = '/products/' + handle + '#dcg-notify';
        });
        row3.appendChild(notifyBtn);
      }

    // ── BRANCH 4: Normal in-stock ─────────────────────────────────────
    } else if (!isSoldOut && inStock.length > 0) {
      let currentQty = 1;
      const effStock = effectiveStockForVariant(inventoryMap, selectedId);
      const stockCap = (effStock !== null) ? effStock : 9999;
      const initialMax = (limitFromTags !== null) ? Math.min(stockCap, limitFromTags) : stockCap;

      const qtyWrap = document.createElement('div');
      qtyWrap.className = 'dcg-qty';
      qtyWrap._limitFromTags = limitFromTags;
      qtyWrap._inventoryMap  = inventoryMap;

      const minusBtn = document.createElement('button');
      minusBtn.className = 'dcg-qty__btn off';
      minusBtn.type = 'button';
      minusBtn.setAttribute('aria-label', 'Decrease quantity' + forName);
      minusBtn.textContent = '−';

      const numSpan = document.createElement('span');
      numSpan.className = 'dcg-qty__num';
      numSpan.textContent = '1';

      const plusBtn = document.createElement('button');
      plusBtn.className = 'dcg-qty__btn';
      plusBtn.type = 'button';
      plusBtn.setAttribute('aria-label', 'Increase quantity' + forName);
      plusBtn.textContent = '+';

      const limitMsg = document.createElement('span');
      limitMsg.className = 'dcg-qty-limit-msg';

      function updateLimitMsg() {
        const limitTag = qtyWrap._limitFromTags;
        if (limitTag !== null && currentQty >= limitTag) {
          limitMsg.textContent = `Limit ${limitTag} per customer`;
          limitMsg.classList.add('visible');
        } else { limitMsg.classList.remove('visible'); }
      }

      qtyWrap._maxQty = initialMax;
      qtyWrap._getQty = () => currentQty;
      qtyWrap._setMax = newMax => {
        qtyWrap._maxQty = newMax; currentQty = 1;
        numSpan.textContent = 1;
        if (hiddenQty) hiddenQty.value = 1;
        minusBtn.classList.add('off');
        plusBtn.classList.toggle('off', 1 >= newMax);
        updateLimitMsg();
      };

      function syncQty() {
        numSpan.textContent = currentQty;
        minusBtn.classList.toggle('off', currentQty <= 1);
        plusBtn.classList.toggle('off', currentQty >= qtyWrap._maxQty);
        if (hiddenQty) hiddenQty.value = currentQty;
        updateLimitMsg();
      }

      plusBtn.classList.toggle('off', 1 >= initialMax);
      updateLimitMsg();

      minusBtn.addEventListener('click', e => { e.stopPropagation(); if (currentQty > 1) { currentQty--; syncQty(); } });
      plusBtn.addEventListener('click',  e => { e.stopPropagation(); if (currentQty < qtyWrap._maxQty) { currentQty++; syncQty(); } });

      qtyWrap.appendChild(minusBtn);
      qtyWrap.appendChild(numSpan);
      qtyWrap.appendChild(plusBtn);
      row3.appendChild(qtyWrap);

      atcBtn.innerHTML = CART_SVG + '<span class="dcg-atc-label">Add to Cart</span>';
      atcBtn.setAttribute('aria-label', 'Add to Cart' + forName);   // V3.1.0 (item 10): the words above are not shown
      atcBtn.dataset.dcgOrigHtml = atcBtn.innerHTML;

      row3.appendChild(actionsEl);
      row3.appendChild(limitMsg);

    // ── BRANCH 5: Sold out / no stock ────────────────────────────────
    } else {
      const notifyBtn = document.createElement('button');
      notifyBtn.className = 'dcg-notify-btn';
      notifyBtn.type = 'button';
      notifyBtn.innerHTML = `<svg viewBox="0 0 20 20" fill="none" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10 2a6 6 0 0 1 6 6c0 3 1.5 4 1.5 5.5H2.5C2.5 12 4 11 4 8a6 6 0 0 1 6-6z" stroke="currentColor"/><path d="M8 15.5a2 2 0 0 0 4 0" stroke="currentColor"/></svg><span>Notify Me</span>`;
      notifyBtn.addEventListener('click', () => {
        const handle = li.getAttribute('data-product-handle');
        if (handle) window.location.href = '/products/' + handle;
      });
      row3.appendChild(notifyBtn);
    }

    frag.appendChild(row3);

    // ── 8. Replace content area ────────────────────────────────────────────
    content.innerHTML = '';
    content.appendChild(frag);

    // ── 9. Price pending (D-SP-14): selected variant is $0.00 ──────────────
    applyPricePending(li, selectedVariant);
  }

  // ── Price block renderer ──────────────────────────────────────────────────
  function _renderPrice(block, variant, fallbackPrice, fallbackCompare, pricePending) {
    block.innerHTML = '';
    if (pricePending) {
      // D-SP-14: never print "$0.00" for a variant that has no price yet.
      const pp = document.createElement('span'); pp.className = 'dcg-card-price dcg-card-price--pending'; pp.textContent = 'Price pending';
      block.appendChild(pp); return;
    }
    if (!variant) {
      const p = document.createElement('span'); p.className = 'dcg-card-price'; p.textContent = fallbackPrice;
      block.appendChild(p); return;
    }
    const price   = Number(variant.price);
    const compare = Number(variant.compare_at_price);
    if (compare && compare > price) {
      const c = document.createElement('span'); c.className = 'dcg-card-compare'; c.textContent = formatMoney(compare);
      block.appendChild(c);
    }
    const p = document.createElement('span'); p.className = 'dcg-card-price'; p.textContent = formatMoney(price) || fallbackPrice;
    block.appendChild(p);
  }

  // ── Condition change handler ──────────────────────────────────────────────
  function onConditionChange(li, variant, selectEl, pip, hiddenVar, hiddenQty) {
    const card      = li.querySelector('.dcg-product-card');
    const content   = card.querySelector('.grid-view-item__meta, .dcg-product-card__content');
    const discountStar = card.querySelector('.dcg-discount-star');

    // Sync hidden inputs (what shop.js reads on ATC click)
    if (hiddenVar) hiddenVar.value = variant.id;
    if (hiddenQty) hiddenQty.value = 1;

    // Keep legacy native select in sync
    const nativeSel = card.querySelector('[data-product-select]');
    if (nativeSel) nativeSel.value = variant.id;

    // Stock pip. V3.1.0, the decisions round: a variant with no stock has none (no such variant can be picked here:
    // a sold-out condition is disabled or not listed); a coming-soon or retail card's stays hidden (D-SP-40)
    pip.className   = `dcg-stock-pip ${pipClass(variant)}`;
    pip.textContent  = pipLabel(variant);
    if (!pip.textContent) pip.style.display = 'none';

    // Price block
    const priceBlock = content && content.querySelector('.dcg-card-price-block');
    if (priceBlock) _renderPrice(priceBlock, variant, '', '', isPricePending(variant, parseTags(li)));

    // Qty reset — re-apply limit tag cap for the new variant
    const qtyWrap = content && content.querySelector('.dcg-qty');
    if (qtyWrap && qtyWrap._setMax) {
      // Re-read stock cap from the Liquid inventory map for the new variant.
      const effStock = effectiveStockForVariant(qtyWrap._inventoryMap || {}, variant.id);
      const stockCap = (effStock !== null) ? effStock : 9999;
      const limitTag = qtyWrap._limitFromTags || null;
      const newMax   = (limitTag !== null) ? Math.min(stockCap, limitTag) : stockCap;
      qtyWrap._setMax(newMax);
    }

    // Price pending (D-SP-14): re-evaluated for the newly selected variant
    applyPricePending(li, variant);

    // Discount star — update % off for the selected variant (or hide if not on sale)
    if (discountStar) {
      const compare = Number(variant.compare_at_price), price = Number(variant.price);
      if (compare && compare > price) {
        discountStar.style.display = '';
        const pctEl = discountStar.querySelector('.dcg-discount-star__pct');
        if (pctEl) pctEl.textContent = `${Math.round((1 - price / compare) * 100)}%`;
      } else { discountStar.style.display = 'none'; }
    }

    // Foil overlay toggle
    const mediaEl = card.querySelector('.dcg-product-card__media');
    if (mediaEl) {
      const hasFoil = isFoilVariant(variant);
      const cardTop2 = card.querySelector('.dcg-card-top');
      if (hasFoil && cardTop2 && !cardTop2.querySelector('.dcg-foil-badge')) {
        const b = document.createElement('span'); b.className = 'dcg-foil-badge'; b.textContent = 'Foil'; cardTop2.appendChild(b);
      } else if (!hasFoil) {
        const badge = card.querySelector('.dcg-foil-badge');
        if (badge) badge.remove();
      }
    }
  }

  // ── Per-card init ─────────────────────────────────────────────────────────
  function initCard(li) {
    if (!li || li.dataset.dcgCardInit === 'true') return;
    li.dataset.dcgCardInit = 'true';
    const variants      = parseVariants(li);
    if (!variants.length) return;
    const limitFromTags  = parseLimitFromTags(li);
    const inventoryMap   = parseInventory(li);

    // D-SP-14: hand every variant's price (cents) and the product's tags to the
    // enforcer, so its pre-flight can refuse a $0.00 variant without asking
    // Shopify. (Its own registry scan reads the same attributes; this covers
    // cards drawn outside the containers it watches.)
    try {
      const enforcer = window.DCG && window.DCG.enforcer;
      if (enforcer && typeof enforcer.registerVariant === 'function') {
        const tags = parseTags(li);
        variants.forEach(v => { if (v && v.id != null) enforcer.registerVariant(v.id, tags, null, v.price); });
      }
    } catch (_) {}

    buildCardUI(li, variants, limitFromTags, inventoryMap);
  }

  function initAll(root) {
    (root || document).querySelectorAll(CARD_SELECTOR).forEach(initCard);
  }

  // ── Boot ──────────────────────────────────────────────────────────────────
  // Consolidated: build cards. (V3.1.0, item 0: the wishlist state was restored here too, until the heart went.)
  document.addEventListener('DOMContentLoaded', () => {
    initAll(document);
    const grid = document.getElementById('CollectionProductGrid');
    if (grid) {
      new MutationObserver(() => initAll(grid))
        .observe(grid, { attributes: true, attributeFilter: ['class'] });
    }
  });

  window.dcgInitProductCards = initAll;

  /* ── Wishlist (V3.1.0, item 0; D-SP-41 amended, LOCKED) ───────────────────
     The card's heart had a delegated click handler here (shop.js binds only the
     buttons present at load) and its cookie helpers. No card carries a heart now.
     The product page's own Add To Wishlist is bound by shop.js (initWishlistButtons),
     as it always was: this handler only ever found that product already in the
     cookie after shop.js's own click, and did nothing. The cookie (wishlistList) is
     left as it is, so anything already hearted stays on /pages/wishlist.
  ────────────────────────────────────────────────────────────────────────── */

  /* ── Whole-card navigation ────────────────────────────────────────────────
     Clicking any non-interactive area of a product card navigates to the
     product page. Interactive elements (buttons, selects, inputs, anchors)
     are excluded so ATC / wishlist / condition select keep working normally.

     Uses a single delegated listener on document so it covers cards injected
     by AJAX filter updates without needing a re-attach. ─────────────────── */
  document.addEventListener('click', function (e) {
    // Match any dcg-product-card outer element — works for collection cards
    // (.dcg-product-card-item), related product cards (.dcg-related-products__item),
    // and any future usage — all share the data-product-handle attribute.
    var card = e.target.closest('[data-product-handle]');
    if (!card) return;

    // Pass through if the click landed on any button / form control
    if (e.target.closest('button, select, input, [role="button"], label, .dcg-qty')) return;

    // Pass through for anchors that manage their own navigation —
    // the title link (.dcg-card-name), wishlist, quick-view, etc.
    // The image link (.dcg-product-card__image-link) is intentionally NOT
    // excluded: we let it fall through to the JS navigation below so the
    // image behaves identically to clicking the card name.
    var anchor = e.target.closest('a');
    if (anchor && !anchor.classList.contains('dcg-product-card__image-link')) return;
    // Image link: suppress the native <a> navigation — JS handles it below
    if (anchor) e.preventDefault();

    // Resolve product URL: prefer the title link (has collection context),
    // fall back to building from the handle data attribute.
    var titleLink = card.querySelector('.dcg-card-name');
    var href = (titleLink && titleLink.href) ? titleLink.href : null;

    if (!href) {
      var handle = card.getAttribute('data-product-handle');
      if (handle) href = '/products/' + handle;
    }

    if (!href) return;

    // Respect Ctrl / Cmd / middle-click intent → open in new tab
    if (e.ctrlKey || e.metaKey || e.shiftKey) {
      window.open(href, '_blank');
    } else {
      window.location.href = href;
    }
  });

  // Re-init cards after AJAX filter/sort updates the product grid.
  // collection-filters-form.js dispatches 'dcg:collection:rendered'
  // after every renderProductGrid() call.
  document.addEventListener('dcg:collection:rendered', function() {
    initAll(document);
  });

  // Theme editor: re-init on every Shopify section reload.
  document.addEventListener('shopify:section:load', function(e) {
    initAll(e.target);
  });
})();